(function() {
    'use strict';

    angular
        .module('app.cupones')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/cupones',
                config: {
                    templateUrl: 'app/cupones/list.html',
                    controller: 'cupones.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-cupon/:id?',
                config: {
                    templateUrl: 'app/cupones/edit.html',
                    controller: 'cupones.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
